<mat-form-field [ngClass]="keyboardFocus === true ? 'keyboard-focus' : ''" class="mat-form-style select__form-field {{cssClasses}}"
                appearance="outline" style='--dropdownHeight:{{dropdownHeight}}px;'>
    <mat-select [formControl]="formFieldControl" class="select__item {{fontSizeClasses}}" [placeholder]="placeholder"
                [(ngModel)]="selectedId"
                [disabled]="disabled"
                [aria-label]="ariaLabel"
                [tabindex]="tabIndex"
                (keyup)="onKeyUp($event)"
                (selectionChange)="valueChanged($event.value)">
        <mat-option *ngIf="showDeselectedOptions">{{placeholder}}</mat-option>
        <mat-option class="select__option {{optionCssClasses}} {{fontSizeClasses}}" *ngFor=" let option of options" [value]="option.selectId"
                    [attr.aria-label]="option.selectValue">
            {{option.selectValue}}
        </mat-option>
    </mat-select>
    <mat-error [attr.aria-invalid]="true"
               *ngIf="formFieldControl.hasError('required')">{{'ERRORS.FIELD_REQUIRED' | translate}}</mat-error>
</mat-form-field>
